import { create } from 'zustand'
import { createSelectors } from '~/shared/lib/zustand-utils'
import type { AuditTrailStep } from './types'

type StepSelectionMode = 'auto' | 'manual'

interface AuditTrailStore {
  stepSelectionMode: StepSelectionMode
  setStepSelectionMode: (stepSelectionMode: StepSelectionMode) => void
  step: null | AuditTrailStep
  setStep: (step: null | AuditTrailStep) => void
  reviewerEmails: string[]
  setReviewerEmails: (reviewerEmails: string[]) => void
  searchQuery: string
  setSearchQuery: (searchQuery: string) => void
  disabledMessage: string | null
  setDisabledMessage: (disabledMessage: string | null) => void
}

const auditTrailStore = createSelectors(
  create<AuditTrailStore>((set) => ({
    stepSelectionMode: 'auto',
    setStepSelectionMode: (stepSelectionMode: StepSelectionMode) => set({ stepSelectionMode }),
    step: null,
    setStep: (step: null | AuditTrailStep) => set({ step }),
    reviewerEmails: [],
    setReviewerEmails: (reviewerEmails: string[]) => set({ reviewerEmails }),
    searchQuery: '',
    setSearchQuery: (searchQuery: string) => set({ searchQuery }),
    disabledMessage: null,
    setDisabledMessage: (disabledMessage: string | null) => set({ disabledMessage }),
  })),
)

export const useAuditTrailStoreSelectors = () => {
  const step = auditTrailStore.use.step()
  const setStep = auditTrailStore.use.setStep()
  const stepSelectionMode = auditTrailStore.use.stepSelectionMode()
  const setStepSelectionMode = auditTrailStore.use.setStepSelectionMode()
  const reviewerEmails = auditTrailStore.use.reviewerEmails()
  const setReviewerEmails = auditTrailStore.use.setReviewerEmails()
  const searchQuery = auditTrailStore.use.searchQuery()
  const setSearchQuery = auditTrailStore.use.setSearchQuery()
  const disabledMessage = auditTrailStore.use.disabledMessage()
  const setDisabledMessage = auditTrailStore.use.setDisabledMessage()
  return {
    step,
    setStep,
    stepSelectionMode,
    setStepSelectionMode,
    reviewerEmails,
    setReviewerEmails,
    searchQuery,
    setSearchQuery,
    disabledMessage,
    setDisabledMessage,
  }
}
